/* One click-loaded, on-page player. Creator navigation is a separate link. */
(function () {
  'use strict';
  if (window.__etProductVideos) return;
  window.__etProductVideos = true;
  var mounted = new Map();

  function externalPlayer(raw) {
    var url;
    try { url = new URL(raw, location.href); } catch (_) { return null; }
    if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
    if (url.username || url.password || url.port) return null;
    var host = url.hostname.toLowerCase();
    var parts = url.pathname.split('/').filter(Boolean);
    var id = '';
    if (host === 'youtu.be' || host === 'www.youtu.be') id = parts[0] || '';
    else if (['youtube.com', 'www.youtube.com', 'm.youtube.com', 'youtube-nocookie.com', 'www.youtube-nocookie.com'].indexOf(host) !== -1) {
      if (parts[0] === 'watch') id = url.searchParams.get('v') || '';
      else if (['shorts', 'embed', 'live'].indexOf(parts[0]) !== -1) id = parts[1] || '';
    }
    if (/^[A-Za-z0-9_-]{11}$/.test(id)) return { src: 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&playsinline=1&rel=0', provider: 'YouTube' };
    if (['vimeo.com', 'www.vimeo.com', 'player.vimeo.com'].indexOf(host) !== -1) {
      if (host === 'player.vimeo.com' && parts[0] === 'video') id = parts[1] || '';
      else if (/^\d+$/.test(parts[0] || '')) id = parts[0];
      else if (parts[0] === 'channels' && parts.length >= 3) id = parts[2];
      else if (parts[0] === 'groups' && parts[2] === 'videos') id = parts[3] || '';
      if (!/^\d{5,12}$/.test(id)) return null;
      var privateHash = url.searchParams.get('h') || (/^\d+$/.test(parts[0] || '') ? parts[1] : '') || '';
      var query = '?autoplay=1&dnt=1';
      if (/^[A-Za-z0-9]+$/.test(privateHash)) query += '&h=' + encodeURIComponent(privateHash);
      return { src: 'https://player.vimeo.com/video/' + id + query, provider: 'Vimeo' };
    }
    if (['instagram.com', 'www.instagram.com', 'm.instagram.com'].indexOf(host) !== -1) {
      if (['reel', 'reels', 'p', 'tv'].indexOf(parts[0]) === -1 || !/^[A-Za-z0-9_-]{6,32}$/.test(parts[1] || '')) return null;
      return { src: 'https://www.instagram.com/p/' + encodeURIComponent(parts[1]) + '/embed/', provider: 'Instagram' };
    }
    if (url.protocol === 'https:' && /\.(mp4|webm|ogv|ogg|m4v)$/i.test(url.pathname)) return { src: url.href, provider: 'Video', native: true };
    return null;
  }

  function profileURL(raw) {
    if (!raw) return '';
    try {
      var url = new URL(raw, location.href);
      return (url.protocol === 'https:' || url.protocol === 'http:') && !url.username && !url.password ? url.href : '';
    } catch (_) { return ''; }
  }

  function initialise(root) {
    if (mounted.has(root)) return;
    var dialog = root.querySelector('[data-product-video-dialog]');
    var stage = root.querySelector('[data-product-video-stage]');
    var close = root.querySelector('[data-product-video-close]');
    var title = root.querySelector('[data-product-video-title]');
    var caption = root.querySelector('[data-product-video-caption]');
    var original = root.querySelector('[data-product-video-original]');
    var creator = root.querySelector('[data-product-video-creator]');
    var status = root.querySelector('[data-product-video-status]');
    if (!dialog || !stage || !close || !title || !caption || !original || !creator || !status || typeof dialog.showModal !== 'function') return;
    var listeners = [];
    var opener = null;
    var savedOverflow = null;
    var activePlayer = null;
    function on(target, type, callback) { target.addEventListener(type, callback); listeners.push(function () { target.removeEventListener(type, callback); }); }
    function stopPlayer() {
      stage.querySelectorAll('video').forEach(function (video) {
        try {
          video.pause();
          video.removeAttribute('src');
          video.querySelectorAll('source').forEach(function (source) { source.removeAttribute('src'); });
          video.load();
        } catch (_) { /* Removing the player still cancels a blocked media request. */ }
      });
      stage.querySelectorAll('iframe').forEach(function (frame) { frame.removeAttribute('src'); });
      stage.replaceChildren();
      activePlayer = null;
      status.textContent = '';
      status.hidden = true;
      original.hidden = true;
      stage.removeAttribute('data-provider');
      stage.removeAttribute('aria-busy');
      dialog.removeAttribute('data-video-aspect');
    }
    function restore() {
      stopPlayer();
      if (savedOverflow !== null) { document.documentElement.style.overflow = savedOverflow; savedOverflow = null; }
      if (opener && opener.isConnected) opener.focus({ preventScroll: true });
      opener = null;
    }
    function dismiss() { if (dialog.open) dialog.close(); else restore(); }
    on(close, 'click', dismiss);
    on(dialog, 'cancel', function (event) { event.preventDefault(); dismiss(); });
    on(dialog, 'close', restore);
    on(dialog, 'click', function (event) {
      if (event.target !== dialog) return;
      var rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dismiss();
    });
    on(window, 'pagehide', dismiss);
    root.querySelectorAll('[data-product-video-link]').forEach(function (link) {
      var card = link.closest('.etp-reel-card');
      var template = card && card.querySelector('[data-product-video-template]');
      var hosted = template && template.content.querySelector('video');
      var external = hosted ? null : externalPlayer(link.href);
      link.setAttribute('aria-haspopup', 'dialog');
      link.setAttribute('aria-label', 'Play ' + (link.dataset.videoTitle || 'Daily Dash video'));
      on(link, 'click', function (event) {
        if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.defaultPrevented) return;
        if (!root.isConnected) return;
        var player;
        if (hosted || (external && external.native)) {
          player = hosted ? hosted.cloneNode(true) : document.createElement('video');
          if (!hosted) player.src = external.src;
          player.controls = true;
          player.playsInline = true;
          player.preload = 'metadata';
          player.setAttribute('aria-label', link.dataset.videoTitle || 'Daily Dash video');
        } else if (external) {
          player = document.createElement('iframe');
          player.title = link.dataset.videoTitle || external.provider + ' video player';
          player.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media';
          player.allowFullscreen = true;
          player.referrerPolicy = 'strict-origin-when-cross-origin';
        }
        stopPlayer();
        opener = link;
        title.textContent = link.dataset.videoTitle || 'Daily Dash, in motion';
        caption.textContent = link.dataset.videoCaption || '';
        caption.hidden = !caption.textContent;
        original.href = link.href;
        var creatorURL = profileURL(link.dataset.videoCreatorUrl);
        creator.hidden = !creatorURL;
        creator.textContent = link.dataset.videoCreator ? 'Visit ' + link.dataset.videoCreator + ' ↗' : 'Visit creator ↗';
        if (creatorURL) creator.href = creatorURL;
        else creator.removeAttribute('href');
        caption.parentElement.hidden = !caption.textContent && !creatorURL;
        dialog.dataset.videoAspect = link.dataset.videoAspect === 'landscape' ? 'landscape' : 'portrait';
        if (player) stage.appendChild(player);
        activePlayer = player;
        try { dialog.showModal(); } catch (_) { stopPlayer(); opener = null; return; }
        event.preventDefault();
        savedOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        close.focus({ preventScroll: true });
        if (!player) {
          stage.dataset.provider = 'unsupported';
          status.textContent = 'This video link does not support on-page playback yet.';
          status.hidden = false;
          original.hidden = !profileURL(link.href);
          return;
        }
        stage.dataset.provider = external ? external.provider.toLowerCase() : 'video';
        stage.setAttribute('aria-busy', 'true');
        status.textContent = 'Loading video…';
        status.hidden = false;
        function ready() {
          if (activePlayer !== player) return;
          stage.removeAttribute('aria-busy');
          status.hidden = true;
        }
        function failed() {
          if (activePlayer !== player) return;
          stage.removeAttribute('aria-busy');
          status.textContent = 'This video could not load. You can try its original source.';
          status.hidden = false;
          original.hidden = false;
        }
        player.addEventListener('error', failed, { once: true });
        if (hosted || external.native) {
          player.addEventListener('loadeddata', ready, { once: true });
          player.addEventListener('playing', ready, { once: true });
          try {
            var playing = player.play();
            if (playing && typeof playing.catch === 'function') playing.catch(function () {
              if (activePlayer !== player || player.error) return;
              stage.removeAttribute('aria-busy');
              status.textContent = 'Press play to start the video.';
              status.hidden = false;
            });
          } catch (_) { failed(); }
        } else {
          player.addEventListener('load', ready, { once: true });
          player.src = external.src;
        }
      });
    });
    mounted.set(root, function () { dismiss(); restore(); listeners.forEach(function (off) { off(); }); });
  }
  function scan(scope) {
    if (scope.matches && scope.matches('[data-product-videos]')) initialise(scope);
    scope.querySelectorAll('[data-product-videos]').forEach(initialise);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); }, { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    mounted.forEach(function (dispose, root) { if (root === event.target || event.target.contains(root)) { dispose(); mounted.delete(root); } });
  });
}());
